const ARTICLES_PER_PAGE = 15;
let currentPage = 1;
let allArticlesData = [];
let filteredArticles = [];

// Initialize pagination on page load
document.addEventListener('DOMContentLoaded', function() {
  if (window.blogArticlesData) {
    allArticlesData = window.blogArticlesData;
    
    // SORT BY UPDATED DATE (NEWEST FIRST)
    filteredArticles = [...allArticlesData].sort((a, b) => {
      const dateA = new Date(a.updated_at || a.published_at || a.created_at || 0);
      const dateB = new Date(b.updated_at || b.published_at || b.created_at || 0);
      return dateB - dateA;
    });
    
    renderArticles(1);
  }
});

function renderArticles(page = 1) {
  const container = document.getElementById('article-container');
  if (!container) return;
  
  const start = (page - 1) * ARTICLES_PER_PAGE;
  const end = start + ARTICLES_PER_PAGE;
  const articlesToShow = filteredArticles.slice(start, end);
  console.log("articlesToShow", articlesToShow);
  
  if (articlesToShow.length === 0) {
    container.innerHTML = '<p style="text-align: center; padding: 40px;">No articles found.</p>';
    document.getElementById('pagination').style.display = 'none';
    return;
  }
  
  container.innerHTML = articlesToShow.map(article => `
    <div class="article-card swiper-slide" data-brand="${article.brand || ''}" data-category="${article.category || ''}">
      ${article.image ? `<a href="${article.url}"><img src="${article.image}" alt="${article.title}"></a><span class="brand_label_data">${article.brand || ''}</span>` : ''}
      <h3 class="article-title">
        <a href="${article.url}">${article.title}</a>
      </h3>
      <a href="${article.url}" class="article-excerpt">${article.excerpt || ''}</a>
      <a class="read-more" href="${article.url}">Read More</a>
    </div>
  `).join('');
  
  document.getElementById('pagination').style.display = 'flex';
  updatePaginationControls();
  
  // Scroll to top after rendering with sticky header offset
  setTimeout(scrollToArticles, 100);
}

function updatePaginationControls() {
  const totalPages = Math.ceil(filteredArticles.length / ARTICLES_PER_PAGE);
  const paginationDiv = document.getElementById('pagination');
  
  if (!paginationDiv) return;
  
  let html = '';
  
  // Previous button
  html += `<button class="pagination-prev" ${currentPage === 1 ? 'disabled' : ''}>‹</button>`;
  
  // Page numbers
  for (let i = 1; i <= totalPages; i++) {
    if (i === currentPage) {
      html += `<button class="pagination-page active" data-page="${i}">${i}</button>`;
    } else {
      html += `<button class="pagination-page" data-page="${i}">${i}</button>`;
    }
  }
  
  // Next button
  html += `<button class="pagination-next" ${currentPage === totalPages ? 'disabled' : ''}>›</button>`;
  
  paginationDiv.innerHTML = html;
  
  // Add event listeners to the new buttons
  attachPaginationEvents();
}

function attachPaginationEvents() {
  // Previous button
  const prevBtn = document.querySelector('.pagination-prev');
  if (prevBtn && !prevBtn.disabled) {
    prevBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (currentPage > 1) {
        currentPage--;
        renderArticles(currentPage);
      }
    });
  }
  
  // Next button
  const nextBtn = document.querySelector('.pagination-next');
  if (nextBtn && !nextBtn.disabled) {
    nextBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const totalPages = Math.ceil(filteredArticles.length / ARTICLES_PER_PAGE);
      if (currentPage < totalPages) {
        currentPage++;
        renderArticles(currentPage);
      }
    });
  }
  
  // Page number buttons
  const pageButtons = document.querySelectorAll('.pagination-page');
  pageButtons.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const page = parseInt(this.dataset.page);
      if (page !== currentPage) {
        currentPage = page;
        renderArticles(currentPage);
      }
    });
  });
}

function scrollToArticles() {
  const stickyHeaderHeight = 102;
  const container = document.getElementById('article-container');
  if (container) {
    const containerPosition = container.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: containerPosition - stickyHeaderHeight - 20,
      behavior: 'smooth'
    });
  }
}

function scrollWithStickyOffset() {
  const stickyHeaderHeight = 102;
  const scrollTarget = document.getElementById('article-container') || 
                       document.querySelector('.headingartic') || 
                       document.querySelector('.articles-grid');
  
  if (scrollTarget) {
    const targetPosition = scrollTarget.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({
      top: targetPosition - stickyHeaderHeight - 20,
      behavior: 'smooth'
    });
  } else {
    window.scrollTo({
      top: stickyHeaderHeight,
      behavior: 'smooth'
    });
  }
}

// Filter function to be called when tags are clicked
function filterArticlesByTag(selectedTag) {
  if (!selectedTag || selectedTag === 'all') {
    // SORT after showing all
    filteredArticles = [...allArticlesData].sort((a, b) => {
      const dateA = new Date(a.updated_at || a.published_at || a.created_at || 0);
      const dateB = new Date(b.updated_at || b.published_at || b.created_at || 0);
      return dateB - dateA;
    });
  } else {
    // SORT after filtering by tag
    filteredArticles = allArticlesData.filter(article => 
      article.tags && article.tags.some(tag => tag.toLowerCase() === selectedTag.toLowerCase())
    ).sort((a, b) => {
      const dateA = new Date(a.updated_at || a.published_at || a.created_at || 0);
      const dateB = new Date(b.updated_at || b.published_at || b.created_at || 0);
      return dateB - dateA;
    });
  }
  currentPage = 1;
  renderArticles(1);
}

// Export for tag click handlers
window.filterArticlesByTag = filterArticlesByTag;
window.goToPage = function(page) {
  currentPage = page;
  renderArticles(currentPage);
};